import { WorkInterval, WorkingHours } from '@chilipiper/api-client-user-availability'
import { isSameDay, endOfDay, isAfter, startOfDay } from '@chilipiper/date-time'
import { CalendarEvent } from '@chilipiper/scheduling-shared'
import { computeEndDate, getCurrentWeekdayDate, invertedWeekDayMap } from './utils'

export const workingHoursToEvents = (scheduleId: string, value: WorkingHours): CalendarEvent[] => {
  return (Object.keys(value) as (keyof WorkingHours)[])
    .map(day => {
      const workingHours = value
      return (workingHours[day] as WorkInterval[]).map((slot: WorkInterval, index) => {
        const weekday = invertedWeekDayMap[day]
        const start = getCurrentWeekdayDate(weekday, slot.startsAt)
        const computedEnd = computeEndDate(start.toISOString(), slot.duration)
        const end = computedEnd ? getEndDate(start, new Date(computedEnd)) : new Date()
        return {
          type: 'External' as const,
          id: `${day}:${index}:${scheduleId}`,
          start,
          end,
          eventType: 'Default' as const,
          interval: {
            start: start.toISOString(),
            end: end.toISOString(),
            type: 'TimeInterval',
          } as const,
        }
      })
    })
    .flat()
}

const getEndDate = (start, end) => {
  if (isSameDay(start, end)) {
    return end
  }

  if (isAfter(end, start)) {
    return endOfDay(start)
  }

  return startOfDay(start)
}
